<section class="main">
  <button *ngIf="add_serviceStatus" class="btn mb-2" (click)="addService()">Add Service</button>
  <button *ngIf="!add_serviceStatus" class="btn mb-2" (click)="back()">Back</button>
  <div class="row">
    <div class="col-md-4">
      <div class="d-flex justify-content-between servMange">
        <p>Services Mangment</p>
        <div class="boxes">
          <img (click)="editMicroService()" class="edit me-2" src="assets/images/edit-64.png">
          <img (click)="deleteService()" data-bs-toggle="modal" data-bs-target="#exampleModal" class="edit"
            src="assets/images/delete.png">
        </div>
      </div>
      <hr class="headeLine">
      <section class="menuItems">
        <div [ngClass]="{'active': item.status == true }" class="box" (click)="serviceDetails(item)"
          *ngFor="let item of list_serives">
          <img src="{{item.image}}" style="width: 60px ; height: 60px;">
          <p>{{ item.name }}</p>
        </div>
      </section>
    </div>
    <div class="col-md-8">
      <section *ngIf="add_serviceStatus && edit_serviceStatus == false" class="menuItems">
        <div class="headMicro d-flex justify-content-between align-items-center">
          <h1>{{ ServiceName }}</h1>
          <button class="btn" (click)="addMicroService()">Add Micro Service</button>
        </div>
        <hr />
        <div class="row">
          <div class="row">
            <div *ngFor="let item of microServiceList" class="col-3 itemContent">
              <img (click)="editMicroService(item)" src="assets/images/edit-64.png" class="editMicroIcon">
              <img src="{{ item.image }}" style="width:132px ; height: 124px;" class="img-fluid" />
              <p class="mb-1 text-truncate">{{ item.name }}</p>
              <p class="mt-1">{{ item.cost }} LE</p>
            </div>
          </div>
        </div>
        <div *ngIf="microServiceList.length == 0">
          <p>No Data Found</p>
        </div>
      </section>
      <section ction *ngIf="!add_serviceStatus && edit_serviceStatus == false" class="menuItems">
        <section *ngIf="!schedules_status">
          <h3>Add Service</h3>
          <hr>
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label>Name</label>
                <input [(ngModel)]="serviceName" type="text" class="form-control" />
              </div>
              <div class="mt-3">
                <mat-slide-toggle [(ngModel)]="disabledApp" name="disabledApp" [color]="color">
                  Disabled in Mobile APP
                </mat-slide-toggle>
              </div>
                <div class="mt-4">
                  <p>Service image</p>
                  <label for="images" class="drop-container">
                    <input (change)="uploadServiceImage($event)" type="file" id="images" accept="image/*" required />
                  </label>
                </div>
              </div>
            </div>
            <div class="mt-4" style="text-align: right">
              <button class="btn add" (click)="next()">Next</button>
            </div>
        </section>
        <section *ngIf="schedules_status">
          <h3>Add Service</h3>
          <hr>
          <p>Date</p>
          <form [formGroup]="suchdelFrom">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>From</label>
                  <input formControlName="valid_from" type="datetime-local" class="form-control" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>To</label>
                  <input formControlName="valid_to" type="datetime-local" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <div class="form-group">
                  <label>Duration</label>
                  <input formControlName="duration" type="number" class="form-control" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Capacity</label>
                  <input formControlName="capacity" type="number" class="form-control" />
                </div>
              </div>
            </div>
          </form>
          <div class="mt-4" style="text-align: right">
            <button (click)="addServices()" class="btn add">Add Service</button>
          </div>
        </section>
      </section>
      <section *ngIf="edit_serviceStatus" class="menuItems">
        <h3>Edit Service</h3>
        <hr>
        <div *ngIf="!schudleEdit">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Name</label>
                <input [(ngModel)]="serviceNameEdit" type="text" class="form-control" />
              </div>
              <div class="form-group mt-3" *ngIf="servicCost != ''">
                <label>Cost</label>
                <input [(ngModel)]="servicCost" type="text" class="form-control" />
              </div>
              <div class="mt-3" *ngIf="servicCost == ''">
                <mat-slide-toggle [(ngModel)]="disabledApp" name="disabledApp" [color]="color">
                  Disabled in Mobile APP
                </mat-slide-toggle>
              </div>

            </div>
          </div>
          <div class="mt-4">
            <p>Service image</p>
            <div *ngIf="serviceImageEdit != ''" class="imageIcon">
              <span (click)="deletImage()">
                <img src="assets/images/delete.png">
              </span>
              <img src="{{serviceImageEdit}}" style="width:100px">
            </div>
            <label *ngIf="serviceImageEdit == ''" for="images" class="drop-container">
              <input (change)="uploadServiceImageEdit($event)" type="file" id="images" accept="image/*" required />
            </label>
          </div>
          <div class="mt-4" style="text-align: right">
            <button *ngIf="servicCost == ''" (click)="EditService()" class="btn add">Next</button>
            <button *ngIf="servicCost != ''" (click)="EditService()" class="btn add">Edit Service</button>
          </div>
        </div>
        <div *ngIf="schudleEdit">
          <p>Date</p>
          <form [formGroup]="suchdelFrom">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>From</label>
                  <input formControlName="valid_from" type="datetime-local" class="form-control" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>To</label>
                  <input formControlName="valid_to" type="datetime-local" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <div class="form-group">
                  <label>Duration</label>
                  <input formControlName="duration" type="number" class="form-control" />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Capacity</label>
                  <input formControlName="capacity" type="number" class="form-control" />
                </div>
              </div>
            </div>
          </form>
          <div class="mt-4" style="text-align: right">
            <button (click)="addServices()" class="btn add">Edit Service</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <p>Are you sure to delete this service</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Yes</button>
        <button type="button" style="background: none ; color: #000" class="btn" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>